import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import './styles/index.css';
import App from './App';
import { AppProvider } from './providers/AppContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
    
  //</React.StrictMode>
);

